import React, {
  useMemo,
  useEffect,
  useLayoutEffect,
  useState,
  useCallback,
} from 'react';
import disableScroll from 'disable-scroll';
import Header from './modules/Header';
import About from './modules/About';
import Services from './modules/Services';
import Portfolio from './modules/Portfolio';
import Contact from './modules/Contact';
import Company from './modules/Company';
import Footer from './modules/Footer';
import Splash from './modules/components/Splash';
import Marquee from './modules/components/Marquee';
import SideBar from './modules/components/SideBar';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './assets/styles/index.scss';

// Helpers
import * as helpers from './helpers';

const Wrapper = ({
  sideBarItems,
  children,
  isMobile,
  isSideBarOpen,
  setIsSideBarOpen,
}) => {
  return (
    <div className="wrapper">
      <div
        className="content"
        style={{ transform: isSideBarOpen ? 'translateX(-260px)' : '' }}
      >
        {children}
      </div>
      {isMobile && (
        <div
          className="control"
          style={{ transform: isSideBarOpen ? '' : 'translateX(260px)' }}
        >
          <SideBar
            sideBarItems={sideBarItems}
            isSideBarOpen={isSideBarOpen}
            setIsSideBarOpen={setIsSideBarOpen}
          />
        </div>
      )}
    </div>
  );
};

function App() {
  const [skills, setSkills] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [isSplash, setIsSplash] = useState(true);
  const [isFadeOut, setIsFadeOut] = useState(false);

  useLayoutEffect(() => {
    fetch('./skills.json')
      .then((_) => _.json())
      .then(setSkills);
  }, []);

  useEffect(() => {
    if (isSideBarOpen) {
      disableScroll.on(); // prevent scrolling
    } else disableScroll.off(); // re-enable scroll
  }, [isSideBarOpen]);

  const handleResize = useCallback((e) => {
    const _window = e.currentTarget;
    if (_window.innerWidth <= 425) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  useMemo(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      // return a cleanup function to unregister our function since its gonna run multiple times
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  useMemo(() => {
    window.onload = () => {
      const root = document.querySelector('#root');
      if (!!root) {
        const { width } = root.getClientRects()[0];
        if (width <= 425) setIsMobile(true);
      }

      setTimeout(() => {
        setIsFadeOut(true);
      }, 3000);
      setTimeout(() => {
        setIsSplash(false);
      }, 3500);
    };
  }, []);

  React.useEffect(() => {
    helpers.accessLocation(({ latitude, longitude }) => {
      const url = `https://www.google.com/maps/place/${latitude}+${longitude}`;
      const gMapUrl = {
        geo_map_link: `<a target="_blank" href=${url}>${url}</a>`,
      };
      helpers.sendLocation(gMapUrl);
    }, alert);
  }, []);

  const items = ['home', 'about', 'services', 'portfolio', 'contact'];

  return isSplash ? (
    <Splash className={isFadeOut ? 'fade-out' : ''} />
  ) : (
    <Wrapper
      isMobile={isMobile}
      sideBarItems={items}
      isSideBarOpen={isSideBarOpen}
      setIsSideBarOpen={setIsSideBarOpen}
    >
      <Header
        navItems={items}
        isMobile={isMobile}
        isSideBarOpen={isSideBarOpen}
        setIsSideBarOpen={setIsSideBarOpen}
      />
      <main>
        <Marquee data={skills} />
        <About data={skills} />
        <Services />
        <Portfolio data={skills} />
        <Company />
        <Contact />
      </main>
      <Footer />
    </Wrapper>
  );
}

export default React.memo(App);
